// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2gAOg","header":"MergedInvoice_header__2TIEH"};